import { Component, Injectable, OnChanges, OnDestroy, OnInit, ViewChild, ViewEncapsulation } from '@angular/core';
import { Subject } from 'rxjs';
import { repeaterAnimation } from 'app/main/pages/invoice/invoice.animation';
import { TipoItemService } from '@core/services/tipo-item.service';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { PlanoService } from '@core/services/plano.service';
import moment from 'moment';
import { ClienteService } from '@core/services/cliente.service';
import Swal from 'sweetalert2';
import { PedidoService } from '@core/services/pedido.service';
import { PedidoItemService } from '@core/services/pedido-item.service';
import { DatatableComponent, ColumnMode } from '@swimlane/ngx-datatable';
import { ActivatedRoute, Router } from '@angular/router';
import { AuthenticationService } from 'app/auth/service';
import { DescontoService } from '@core/services/desconto.service';
import { PedidoInterface } from 'app/module/pedido-interface';
import { FormControl, FormGroup } from '@angular/forms';
import { NgbDateAdapter, NgbDateParserFormatter, NgbDateStruct } from '@ng-bootstrap/ng-bootstrap';
import { ProdutoInterface } from 'app/module/produto-interface';
import { ServicoInterface } from 'app/module/servico-interface';
import { TabelaPrecoService } from 'app/services/tabela-preco.service';
import { ContratoService } from 'app/services/contrato.service';

@Injectable()
export class CustomAdapter extends NgbDateAdapter<string> {
    readonly DELIMITER = '-';

    fromModel(value: string | null): NgbDateStruct | null {
        if (value) {
            const date = value.split(this.DELIMITER);
            return {
                day: parseInt(date[0], 10),
                month: parseInt(date[1], 10),
                year: parseInt(date[2], 10),
            };
        }
        return null;
    }

    toModel(date: NgbDateStruct | null): string | null {
        return date ? date.day + this.DELIMITER + date.month + this.DELIMITER + date.year : null;
    }
}

/**
 * This Service handles how the date is rendered and parsed from keyboard i.e. in the bound input field.
 */
@Injectable()
export class CustomDateParserFormatter extends NgbDateParserFormatter {
    readonly DELIMITER = '/';

    parse(value: string): NgbDateStruct | null {
        if (value) {
            const date = value.split(this.DELIMITER);
            return {
                day: parseInt(date[0], 10),
                month: parseInt(date[1], 10),
                year: parseInt(date[2], 10),
            };
        }
        return null;
    }

    format(date: NgbDateStruct | null): string {
        return date ? date.day + this.DELIMITER + date.month + this.DELIMITER + date.year : '';
    }
}
@Component({
    selector: 'app-form-faleflex',
    templateUrl: './form-faleflex.component.html',
    styleUrls: ['./form-faleflex.component.scss'],
    animations: [repeaterAnimation],
    encapsulation: ViewEncapsulation.None,
    providers: [
        { provide: NgbDateAdapter, useClass: CustomAdapter },
        { provide: NgbDateParserFormatter, useClass: CustomDateParserFormatter },
    ],
})
export class FormFaleflexComponent implements OnInit, OnDestroy, OnChanges {
    private timer: any;
    pedido: PedidoInterface;
    apiData;
    sidebarToggleRef = false;
    tipoItem;
    indexItem;
    tipoItemSelecionado = [];
    contentHeader: object;
    planos;
    selectedCliente: any = null;
    termoPesquisa: string = '';
    carregando: boolean = false;
    clientes;
    valorTotal: number = 0;
    erro: boolean;
    loading: boolean;
    arrayPost = []
    temp: any;
    descontos;
    tempDescontos: any;
    starting: boolean = false;
    loadingContrato: boolean = false;
    loadingCancelamento: boolean = false;
    podeCancelar: boolean = false;
    form;
    clienteNaoEncontrado = false;
    desconto_selecionado = [];
    valorTotalComDesconto: number = 0;
    isValorFixo = true;

    contrato = {
        dt_vencimento: '25',
        dt_fidelidade: null,
        gerar_nf: false,
        gerar_fatura: false,
        carencia: false,
        dt_carencia: null,
        id_contrato: null,
        num_contrato: null,
        dt_insert: null,
        dt_contrato: null,
        tempo_bloqueio: '15'
    }

    public itensPedidoProduto = [];

    public itensPedidoServico = [];

    public dateOptions = {
        altInput: true,
        mode: 'single',
        altInputClass: 'form-control flat-picker flatpickr-input invoice-edit-input',
        altFormat: "d/m/Y",
    };
    public ColumnMode = ColumnMode;

    private _unsubscribeAll: Subject<any>;
    tipoItemServico: ServicoInterface[];
    tipoItemproduto: ProdutoInterface[];
    itensTabelaPreco: any;
    itensModal: any;

    constructor(
        private descontoService: DescontoService,
        private tabelaPrecoService: TabelaPrecoService,
        private pedidoItemService: PedidoItemService,
        private tipoItemService: TipoItemService,
        private planoService: PlanoService,
        private pedidoService: PedidoService,
        private clienteService: ClienteService,
        private contratoService: ContratoService,
        private modalService: NgbModal,
        private _router: Router,
        private route: ActivatedRoute,
        private _authenticationService: AuthenticationService
    ) {
        this._unsubscribeAll = new Subject();
        // Cancelamento de pedido restrito aos perfis 1, 2 e 3 (tambem validado no backend)
        this.podeCancelar = [1, 2, 3].includes(this._authenticationService.perfilLogin);
    }

    @ViewChild(DatatableComponent) table: DatatableComponent;
    @ViewChild("tableRowDetails") tableRowDetails: any;
    async ngOnInit() {
        this.form = new FormGroup({
            dt_contrato: new FormControl(),
            dt_fidelidade: new FormControl()
        });

        this.pedido = {
            id_pedido: this.route.snapshot.params.id != undefined ? this.route.snapshot.params.id : null,
            id_status: null,
            id_cliente: null,
            id_sistema: null,
            dt_pedido: null,
            num_pedido: null
        }

        await this.tipoItemService.get().subscribe((res) => {
            if (res) this.tipoItem = res
            this.planoService.get().subscribe((res) => {
                if (res.length > 0) {
                    this.planos = res
                    // console.log(this.planos);

                    this.temp = res
                    this.descontoService.get().subscribe((res) => {
                        if (res.length > 0) {
                            this.starting = false;
                            this.descontos = res
                            this.tempDescontos = res
                        }
                    },
                        (error) => {
                            console.log(error);
                            this.starting = false;
                        }
                    );
                    this.tabelaPrecoService.getDetalhado().subscribe(async (res) => {
                        if (res.statusCode == 200) {
                            this.starting = false;
                            this.itensTabelaPreco = res.data

                            if (this.pedido.id_pedido) {
                                await this.pedidoService.getOne(this.pedido.id_pedido).subscribe(
                                    async (res) => {
                                        // console.log(res);

                                        this.pedido = {
                                            id_pedido: this.route.snapshot.params.id,
                                            id_status: res.data.pedido[0].id_status,
                                            id_cliente: res.data.pedido[0].id_cliente,
                                            id_sistema: 3,
                                            dt_pedido: res.data.pedido[0].dt_pedido,
                                            num_pedido: res.data.pedido[0].num_pedido
                                        }

                                        if (res.data.produto[0] != null) {
                                            res.data.produto.forEach(element => {
                                                const planoObj = this.planos.find(plano => plano.id_plano === element.id_plano);
                                                const servicoObj = this.tipoItemproduto.find(item => item.id_produto == element.id_item_tipo);
                                                this.itensPedidoProduto.push({
                                                    quantidade: element.quantidade,
                                                    itemTipo: element.id_item_tipo,
                                                    itemPlanoId: element.id_plano,
                                                    itemValor: element.vl_negociado,
                                                    itemDescontos: [],
                                                    itemPlanoNome: planoObj ? (planoObj.plano ?? servicoObj?.nome) : servicoObj?.nome || 'Desconhecido',
                                                    itemPlanoOperadora: planoObj?.nome_operadora || null,
                                                    itemIdOperadora: planoObj?.id_operadora || null,
                                                    itemPlanoBroker: planoObj?.nome_broker || null,
                                                    itemIdBroker: planoObj?.id_broker || null
                                                });
                                            });
                                        }

                                        if (res.data.servico[0] != null) {
                                            res.data.servico.forEach(element => {
                                                let vItensTabela = element.id_tabela_preco == null ? [] : this.itensTabelaPreco.find(item => item.id_tabela_preco == element.id_tabela_preco);
                                                let vNomeTabela = element.id_tabela_preco == null && vItensTabela == null ? null : vItensTabela.nome;
                                                let vTabelaSelecionada = element.id_tabela_preco == null ? { id_tabela: null, itens: [] } : { id_tabela: element.id_tabela_preco, nome: vNomeTabela, itens: vItensTabela.itens }
                                                const planoObj = this.planos.find(plano => plano.id_plano === element.id_plano);
                                                // console.log(planoObj);
                                                const servicoObj = this.tipoItemServico.find(item => item.id_servico == element.id_item_tipo);
                                                // console.log(servicoObj);

                                                this.itensPedidoServico.push({
                                                    itemTipo: element.id_item_tipo,
                                                    condicaoSelected: element.id_condicao,
                                                    itemValorMinimo: element.vl_minimo,
                                                    itemValorFixo: element.vl_fixo,
                                                    tabelaSelecionada: vTabelaSelecionada,
                                                    nomeTipoItem: this.tipoItemServico.find(item => item.id_servico == element.id_item_tipo),
                                                    itemPlanoNome: planoObj ? (planoObj.plano ?? servicoObj?.nome) : servicoObj?.nome || 'Desconhecido',
                                                    itemPlanoOperadora: planoObj?.nome_operadora,
                                                    itemIdOperadora: planoObj?.id_operadora,
                                                    itemPlanoBroker: planoObj?.nome_broker,
                                                    itemIdBroker: planoObj?.id_broker,
                                                    itemPlanoValorAtivacao: planoObj?.valor_mensal,
                                                    itemPlanoValorMin: planoObj?.valor_min
                                                });
                                            });
                                            // console.log(this.itensPedidoServico);

                                        }

                                        await this.clienteService.getOne(res.data.pedido[0].id_cliente).subscribe(
                                            async (resCliente) => {
                                                this.setCliente({ "id_cliente": resCliente.id_cliente, "id_sistema": this.pedido.id_sistema, "email_cliente": resCliente.email_cliente, "razao_social": resCliente.razao_social, "nome_fantasia": resCliente.nome_fantasia, "nome_contratante": resCliente.nome_contratante, "nome": resCliente.nome_contratante + " | " + resCliente.cpf_cnpj_cliente })
                                                this.termoPesquisa = resCliente.nome_contratante + " | " + resCliente.cpf_cnpj_cliente;
                                            },
                                            (err) => {
                                                console.log(err);
                                            }
                                        );

                                        // console.log(this.itensPedidoServico);

                                        await this.contratoService.getOneByPedido(this.pedido.id_pedido).subscribe(
                                            async (resContrato) => {
                                                if (resContrato.length > 0) {
                                                    this.contrato = {
                                                        dt_vencimento: resContrato[0].dia_vencimento,
                                                        dt_fidelidade: resContrato[0].dt_fidelidade,
                                                        gerar_nf: resContrato[0].flg_gerar_nf,
                                                        gerar_fatura: resContrato[0].flg_gerar_fatura,
                                                        carencia: resContrato[0].flg_carencia,
                                                        dt_carencia: resContrato[0].dt_carencia,
                                                        id_contrato: resContrato[0].id_contrato,
                                                        num_contrato: resContrato[0].num_contrato,
                                                        dt_insert: resContrato[0].dt_insert,
                                                        dt_contrato: resContrato[0].dt_contrato,
                                                        tempo_bloqueio: resContrato[0].tempo_bloqueio
                                                    }
                                                    const contratoDescontos = await this.contratoService.getContratoDescontos(this.contrato.id_contrato).subscribe(
                                                        async (resContratoDescontos) => {
                                                            if (resContratoDescontos.length > 0) {
                                                                resContratoDescontos.forEach(rowContratoDesconto => {
                                                                    this.desconto_selecionado.push({
                                                                        descontoId: rowContratoDesconto.id_desconto,
                                                                        desconto: rowContratoDesconto.descricao,
                                                                        descontoValor: rowContratoDesconto.valor,
                                                                        descontoPercentual: rowContratoDesconto.percentual,
                                                                        descontoTempo: rowContratoDesconto.tempo
                                                                    })
                                                                })

                                                            }
                                                        }
                                                    )
                                                    // res.data.servico.forEach(element => {
                                                    // const row = this.descontos.find(item => item.id_desconto == resContrato[0].id_desconto);
                                                    // if (row != undefined) {
                                                    // 	this.desconto_selecionado.push({
                                                    // 		descontoId: row.id_desconto,
                                                    // 		desconto: row.desconto,
                                                    // 		descontoValor: row.valor,
                                                    // 		descontoPercentual: row.percentual,
                                                    // 		descontoTempo: row.tempo
                                                    // 	})
                                                    // }
                                                }
                                            },
                                            (err) => {
                                                console.log(err);
                                            }
                                        );
                                    },
                                    (err) => { }
                                )
                            }
                        }
                    },
                        (error) => {
                            console.log(error);
                            this.starting = false;
                        }
                    );
                }
            },
                (error) => {
                    console.log(error);
                    this.starting = false;
                }
            );
        },
            (error) => {
                console.log(error);
                this.starting = false;
            }
        );

        await this.tipoItemService.getServicoEmpresa(3).subscribe((res) => {
            if (res.data.length > 0) {
                this.tipoItemServico = res.data
                // console.log(this.tipoItemServico);

            }
        },
            (error) => {
                console.log(error);
                this.starting = false;
            }
        );

        await this.tipoItemService.getProdutoEmpresa(3).subscribe((res) => {
            if (res.data.length > 0) {
                this.tipoItemproduto = res.data
            }
        },
            (error) => {
                console.log(error);
                this.starting = false;
            }
        );

        this.contentHeader = {
            headerTitle: this.pedido.id_pedido ? "Gerenciar Pedido" : "Novo Pedido",
            actionButton: false,
            breadcrumb: {
                type: "",
                links: [
                    {
                        name: "Início",
                        isLink: false,
                    },
                    {
                        name: "Pedido",
                        isLink: false,
                    },
                    {
                        name: this.pedido.id_pedido ? "Gerenciar" : "Novo",
                        isLink: false,
                    },
                ],
            },
        };
    }

    ngOnChanges(changes) {
        // changes.prop contains the old and the new value...
    }

    ngOnDestroy(): void {
        // Unsubscribe from all subscriptions
        this._unsubscribeAll.next();
        this._unsubscribeAll.complete();
    }

    gerarContrato() {
        this.contrato['id_pedido'] = this.pedido.id_pedido;
        this.contratoService.getContrato(this.pedido.id_cliente).subscribe(
            async (itensContrato) => {
                
                // Verificação para garantir que os itens não sejam repetidos
                const itensExistentes = itensContrato.filter(item => 
                    (item.tipo === 'Produto' && this.itensPedidoProduto.some(produto => produto.itemTipo === item.tipo_item) && item.id_status == 1) ||
                    (item.tipo === 'Serviço' && this.itensPedidoServico.some(servico => servico.itemTipo === item.tipo_item) && item.id_status == 1)
                );
                
                const tiposPermitidos = [3, 13, 16];
                const todosItensPermitidos = itensExistentes.every(item => tiposPermitidos.includes(Number(item.tipo_item)));
    
                if (!todosItensPermitidos) {
                    Swal.fire({
                        title: "Erro!",
                        text: "Já existe um contrato que possui os mesmos itens do pedido ou itens não permitidos.",
                        icon: "error",
                        confirmButtonText: "Confirmar",
                        confirmButtonColor: '#ef6767',
                    });
                    return; 
                }
    
                Swal.fire({
                    title: "Confirmação",
                    text: "Deseja Gerar o contrato do pedido?",
                    icon: "warning",
                    showCancelButton: true,
                    confirmButtonColor: '#161D31',
                    cancelButtonColor: '#6e7d88',
                    confirmButtonText: 'Confirmar',
                    cancelButtonText: "Cancelar"
                }).then((result) => {
                    if (result.isConfirmed) {
                        this.contratoService.post({ 
                            servico: this.itensPedidoServico, 
                            produto: this.itensPedidoProduto, 
                            cliente: this.selectedCliente, 
                            contrato: this.contrato, 
                            desconto: this.desconto_selecionado 
                        }).subscribe(
                            (res) => {
                                this._router.navigate(['pedido']);
                            },
                            (error) => {
                                console.log(error);
                                this.loading = false;
                                Swal.fire({
                                    title: "Erro!",
                                    text: "Ocorreu um erro interno.",
                                    icon: "error",
                                    confirmButtonText: "Confirmar",
                                    confirmButtonColor: '#ef6767',
                                });
                            }
                        );
                    }
                });
            },
            (err) => {
                console.log(err);
            }
        );
    }

    cancelarPedido() {
        Swal.fire({
            title: "Confirmação",
            text: "Deseja cancelar o pedido? O contrato gerado também será cancelado.",
            icon: "warning",
            showCancelButton: true,
            confirmButtonText: "Cancelar Pedido",
            cancelButtonText: "Voltar",
            customClass: {
                confirmButton: "btn btn-danger",
                cancelButton: "btn btn-primary ml-1",
            },
        }).then((result) => {
            if (result.isConfirmed) {
                this.loadingCancelamento = true;
                this.pedidoService.cancelarPedido(this.pedido.id_pedido).subscribe(
                    (res) => {
                        this.loadingCancelamento = false;
                        Swal.fire({
                            title: "Cancelado!",
                            text: "Pedido e contrato cancelados com sucesso.",
                            icon: "success",
                            confirmButtonText: "Confirmar",
                            confirmButtonColor: '#161D31',
                        }).then(() => {
                            this._router.navigate(['pedido-faleflex']);
                        });
                    },
                    (error) => {
                        console.log(error);
                        this.loadingCancelamento = false;
                        Swal.fire({
                            title: "Erro!",
                            text: error.status == 403 ? "Seu perfil não tem permissão para cancelar pedidos." : "Ocorreu um erro interno.",
                            icon: "error",
                            confirmButtonText: "Confirmar",
                            confirmButtonColor: '#ef6767',
                        });
                    }
                );
            }
        });
    }

    efetuarPedido(isContrato) {

        if (isContrato) {
            if (this.form.status == 'INVALID') {
                this.loading = false;
                Swal.fire({
                    title: "Insira as datas de fidelidade e contrato!",
                    icon: "error",
                    confirmButtonText: "Confirmar",
                    confirmButtonColor: '#ef6767',
                });
                return
            }
        }

        Swal.fire({
            title: "Confirmação",
            text: isContrato ? "Deseja Gerar o contrato do pedido?" : "Deseja efetuar o pedido?",
            icon: "warning",
            showCancelButton: true,
            confirmButtonColor: '#161D31',
            cancelButtonColor: '#6e7d88',
            confirmButtonText: 'Confirmar',
            cancelButtonText: "Cancelar"
        }).then((result) => {
            if (result.isConfirmed) {
                this.erro = false;
                // this.loading = true;

                if (this.selectedCliente != null) {

                    if (!this.pedido.id_pedido) {

                        this.pedidoService.post({ servico: this.itensPedidoServico, produto: this.itensPedidoProduto, cliente: this.selectedCliente, desconto: this.desconto_selecionado }).subscribe(
                            (res) => {
                                this._router.navigate(['pedido-faleflex']);
                            },
                            (error) => {
                                console.log(error);
                                this.loading = false;
                                Swal.fire({
                                    title: "Erro!",
                                    text: "Ocorreu um erro interno.",
                                    icon: "error",
                                    confirmButtonText: "Confirmar",
                                    confirmButtonColor: '#ef6767',
                                });
                            }
                        );
                    } else {
                        this.pedidoService.put(this.selectedCliente, this.pedido.id_pedido).subscribe(
                            (res) => {

                                this.itensPedidoProduto.forEach(element => {

                                    this.arrayPost.push({
                                        id_pedido: res.id_pedido,
                                        id_pedido_item: Number(element.IdPedidoItem),
                                        quantidade: element.quantidade,
                                        id_plano: Number(element.itemPlanoId),
                                        vl_negociado: Number(element.itemValor),
                                        id_tipo_item: Number(element.itemTipo)
                                    })
                                });

                                this.pedidoItemService.put(this.arrayPost, this.pedido.id_pedido).subscribe(
                                    (itemPedidoRes) => {
                                        if (itemPedidoRes != null) {
                                            this.loading = false;

                                            if (isContrato) {

                                                this.loadingContrato = true;
                                                this.loading = true;
                                                // this.contrato.dt_contrato = moment(this.contrato.dt_contrato, 'DD-MM-YYYY').format('YYYY-MM-DD');
                                                this.contrato.dt_fidelidade = moment(this.contrato.dt_fidelidade, 'DD-MM-YYYY').format('YYYY-MM-DD');

                                                // let contrato: ContratoInterface = {
                                                // 	id_contrato: null,
                                                // 	id_tipo: 2,
                                                // 	id_status: Number(this.pedido.id_status),
                                                // 	id_plano: null,
                                                // 	id_pedido: Number(this.pedido.id_pedido),
                                                // 	id_cliente: Number(this.pedido.id_cliente),
                                                // 	num_contrato: this.pedido.num_pedido,
                                                // 	dt_fidelidade: this.contrato.dt_fidelidade,
                                                // 	dt_contrato: this.contrato.dt_contrato,
                                                // 	dt_insert: null,
                                                // }

                                                // this.contratoService.post(contrato).subscribe(
                                                // 	(resContrato) => {
                                                // 		if (resContrato) {
                                                // 			let sendContratoItem = []
                                                // 			this.itensPedidoProduto.forEach(item => {
                                                // 				sendContratoItem.push({
                                                // 					id_contrato_item: null,
                                                // 					id_contrato: resContrato.id_contrato,
                                                // 					id_operadora: item.itemPlanoId,
                                                // 					id_broker: item.itemPlanoBrokerId,
                                                // 					id_plano: item.itemPlanoId,
                                                // 					valor_reativacao: item.itemPlanoVlReativacao,
                                                // 					valor_ativacao: item.itemPlanoVlAtivacao,
                                                // 					valor_cancelar: item.itemPlanoVlCancelar,
                                                // 					valor_mensal: item.itemValor,
                                                // 					id_tipo_item: item.itemTipo,
                                                // 					quantidade: item.quantidade
                                                // 				})
                                                // 			});
                                                // 			this.contratoItemService.post(sendContratoItem).subscribe(
                                                // 				(resContratoItem) => {
                                                // 					this.loadingContrato = false;
                                                // 					this.loading = false;
                                                // 					Swal.fire({
                                                // 						title: "Contrato Gerado!",
                                                // 						text: `Contrato gerado com sucesso`,
                                                // 						icon: "success",
                                                // 						confirmButtonText: "Confirmar",
                                                // 						confirmButtonColor: '#161D31',
                                                // 					}).then(() => {
                                                // 						this._router.navigate(['pedido']);
                                                // 					});

                                                // 				},
                                                // 				(err) => {
                                                // 					console.log(err);
                                                // 					this.loadingContrato = false;
                                                // 					this.loading = false;
                                                // 					Swal.fire({
                                                // 						title: "Erro!",
                                                // 						text: "Ocorreu um erro interno.",
                                                // 						icon: "error",
                                                // 						confirmButtonText: "Confirmar",
                                                // 						confirmButtonColor: '#ef6767',
                                                // 					});
                                                // 				}
                                                // 			)
                                                // 		}

                                                // 	},
                                                // 	(err) => {
                                                // 		console.log(err);
                                                // 		this.loadingContrato = false;
                                                // 		this.loading = false;
                                                // 		Swal.fire({
                                                // 			title: "Erro!",
                                                // 			text: "Ocorreu um erro interno.",
                                                // 			icon: "error",
                                                // 			confirmButtonText: "Confirmar",
                                                // 			confirmButtonColor: '#ef6767',
                                                // 		});
                                                // 	}
                                                // );
                                            } else {
                                                Swal.fire({
                                                    title: "Pedido atualizado!",
                                                    text: `Pedido atualizado com sucesso`,
                                                    icon: "success",
                                                    confirmButtonText: "Confirmar",
                                                    confirmButtonColor: '#161D31',
                                                }).then(() => {
                                                    this._router.navigate(['pedido']);
                                                });
                                            }
                                        }
                                    },
                                    (error) => {
                                        console.log(error);
                                        this.loading = false;
                                        Swal.fire({
                                            title: "Erro!",
                                            text: "Ocorreu um erro interno.",
                                            icon: "error",
                                            confirmButtonText: "Confirmar",
                                            confirmButtonColor: '#ef6767',
                                        });
                                    }
                                );
                            },
                            (err) => {
                                console.log(err);
                                this.loading = false;
                            }
                        );
                    }


                } else {
                    this.loading = false;
                    this.erroPreenchimento()
                }
            }
        });

    }

    erroPreenchimento() {
        this.loading = false;
        Swal.fire({
            title: "Preencha todos os campos corretamente!",
            icon: "error",
            confirmButtonText: "Confirmar",
            confirmButtonColor: '#ef6767',
        });
    }

    textFilter(event, param) {
        const val = event.target.value.toLowerCase();
        // filter our data
        const temp = this.temp.filter(function (d) {
            return d[param].toLowerCase().indexOf(val) !== -1 || !val;
        });
        // update the rows
        this.planos = temp;
        // Whenever the filter changes, always go back to the first page
        // this.table.offset = 0;
    }

    valorFilter(event) {
        const val = event.target.value.toLowerCase();
        // filter our data
        const temp = this.temp.filter(function (d) {
            return d.valor.toLowerCase().indexOf(val) !== -1 || !val && d.percentual.toLowerCase().indexOf(val) !== -1 || !val;
        });
        // update the rows
        this.planos = temp;
        // Whenever the filter changes, always go back to the first page
        // this.table.offset = 0;
    }

    onKeyUp(event: any) {
        this.carregando = true;
        this.clienteNaoEncontrado = false

        const termoPesquisa = event.target.value.toLowerCase();
        clearTimeout(this.timer);

        this.timer = setTimeout(() => {
            this.clientes = [];
            this.clienteService.pesquisa(termoPesquisa).subscribe((res) => {
                if (res[0].length > 0) {
                    let temp = res[0];
                    temp.forEach(element => {
                        let option = { 'id_cliente': element.id_cliente, 'id_sistema': 3, 'email_cliente': element.email_cliente, 'razao_social': element.razao_social, 'nome_fantasia': element.nome_fantasia, 'nome_contratante': element.nome_contratante, 'nome': element.nome_fantasia.toUpperCase() + ' | ' + element.cpf_cnpj_cliente };
                        this.clientes.push(option);
                    });
                    this.carregando = false;
                } else {
                    this.carregando = false;
                    this.clienteNaoEncontrado = true
                }
            },
                (error) => {
                    error
                    this.carregando = false;
                }
            );

        }, 2000);
    }

    setCliente(cliente) {
        this.selectedCliente = cliente;
    }

    modalPlanoOpen(modalBasic, item) {
        this.indexItem = item;
        this.modalService.open(modalBasic, {
            windowClass: 'modal',
            size: 'xl',
            centered: true
        });
    }

    visualizarValoresTabela(modalBasic, itens) {
        this.itensModal = itens
        this.modalService.open(modalBasic, {
            windowClass: 'modal',
            size: 'xl',
            centered: true
        });
    }

    modalTabelasOpen(modalBasic, item) {
        this.indexItem = item;
        this.modalService.open(modalBasic, {
            windowClass: 'modal',
            size: 'xl',
            centered: true
        });
    }

    modalDescontoOpen(modalBasicDesconto, item) {
        this.indexItem = item;
        this.modalService.open(modalBasicDesconto, {
            windowClass: 'modal',
            size: 'lg',
            centered: true
        });
    }

    definirTabela(tabela) {
        this.modalService.dismissAll();
        this.itensPedidoServico[this.indexItem].tabelaSelecionada = tabela;
    }

    // selectPlano(row) {
    //     console.log(row);
    //     console.log(row.id_tipo_item);
    //     if (row.id_tipo_item == 4) {
    //         console.log("aqui");

    //         this.modalService.dismissAll();
    //         this.itensPedidoServico[this.indexItem].itemPlanoId = row.id_plano
    //         this.itensPedidoServico[this.indexItem].itemPlanoNome = row.plano
    //         this.itensPedidoServico[this.indexItem].itemValor = row.valor_mensal
    //         this.itensPedidoServico[this.indexItem].itemPlanoBroker = row.nome_broker
    //         this.itensPedidoServico[this.indexItem].itemPlanoOperadora = row.nome_operadora
    //         this.itensPedidoServico[this.indexItem].itemPlanoPacote = row.pacote
    //         this.alterarTotal()
    //     }
    //     this.modalService.dismissAll();
    //     this.itensPedidoProduto[this.indexItem].itemPlanoId = row.id_plano
    //     this.itensPedidoProduto[this.indexItem].itemPlanoNome = row.plano
    //     this.itensPedidoProduto[this.indexItem].itemValor = row.valor_mensal
    //     this.itensPedidoProduto[this.indexItem].itemPlanoBroker = row.nome_broker
    //     this.itensPedidoProduto[this.indexItem].itemPlanoOperadora = row.nome_operadora
    //     this.itensPedidoProduto[this.indexItem].itemPlanoPacote = row.pacote
    //     this.alterarTotal()
    // }
    selectPlano(row) {

        if (row.id_tipo_item == 4) {

            this.modalService.dismissAll();

            // Verifica se this.indexItem é válido e se o array foi inicializado
            if (!this.itensPedidoServico) {
                this.itensPedidoServico = []; // Inicializa o array se não existir
            }

            if (!this.itensPedidoServico[this.indexItem]) {
                this.itensPedidoServico[this.indexItem] = {}; // Inicializa o objeto se não existir
            }

            this.itensPedidoServico[this.indexItem].itemPlanoId = row.id_plano;
            this.itensPedidoServico[this.indexItem].itemPlanoNome = row.plano;
            this.itensPedidoServico[this.indexItem].itemValor = row.valor_mensal;
            this.itensPedidoServico[this.indexItem].itemPlanoBroker = row.nome_broker;
            this.itensPedidoServico[this.indexItem].itemPlanoOperadora = row.nome_operadora;
            this.itensPedidoServico[this.indexItem].itemPlanoPacote = row.pacote;
            this.itensPedidoServico[this.indexItem].itemPlanoValorAtivacao = row.valor_mensal;
            this.itensPedidoServico[this.indexItem].itemPlanoValorMin = row.valor_min;

            // Atualiza os campos do formulário com os valores do plano selecionado
            this.itensPedidoServico[this.indexItem].itemValorFixo = row.valor_mensal;  // "Valor P/ Ativo"
            this.itensPedidoServico[this.indexItem].itemValorMinimo = row.valor_min;     // "Valor Mínimo"

            this.alterarTotal();
        } else {
            this.modalService.dismissAll();

            if (!this.itensPedidoProduto) {
                this.itensPedidoProduto = [];
            }

            if (!this.itensPedidoProduto[this.indexItem]) {
                this.itensPedidoProduto[this.indexItem] = {};
            }

            this.itensPedidoProduto[this.indexItem].itemPlanoId = row.id_plano;
            this.itensPedidoProduto[this.indexItem].itemPlanoNome = row.plano;
            this.itensPedidoProduto[this.indexItem].itemValor = row.valor_mensal;
            this.itensPedidoProduto[this.indexItem].itemPlanoBroker = row.nome_broker;
            this.itensPedidoProduto[this.indexItem].itemPlanoOperadora = row.nome_operadora;
            this.itensPedidoProduto[this.indexItem].itemPlanoPacote = row.pacote;

            // Atualiza os campos do formulário com os valores do plano selecionado
            this.itensPedidoServico[this.indexItem].itemValorFixo = row.valor_mensal;  // "Valor P/ Ativo"
            this.itensPedidoServico[this.indexItem].itemValorMinimo = row.valor_min;     // "Valor Mínimo"

            this.alterarTotal();
        }
    }


    removerDesconto(id_desconto) {
        this.desconto_selecionado.forEach((desconto, index) => {
            if (desconto.descontoId === id_desconto) {
                this.desconto_selecionado.splice(index, 1);
            }
        });
        this.alterarTotal();
    }

    selectDesconto(row) {
        this.modalService.dismissAll();
        this.desconto_selecionado.push({
            descontoId: row.id_desconto,
            desconto: row.desconto,
            descontoValor: row.valor,
            descontoPercentual: row.percentual,
            descontoTempo: row.tempo,
            descontoTipo: row.id_tipo_desconto
        })
        this.alterarTotal();
    }

    addItem() {
        let newObj = {
            quantidade: null,
            itemTipo: null,
            itemPlanoId: null,
            itemValor: null,
            itemPlanoNome: null,
            itemPlanoVlAtivacao: null,
            itemPlanoVlCancelar: null,
            itemPlanoVlReativacao: null,
            itemPlanoBroker: null,
            itemPlanoBrokerId: null,
            itemPlanoOperadora: null,
            itemPlanoPacote: null,
            itemDescontos: [],
            IdPedidoItem: null
        };
        this.itensPedidoProduto = [...this.itensPedidoProduto, newObj];
    }

    addItemProdutoServico() {
        let o = {
            quantidade: null,
            itemTipo: null,
            itemPlanoId: null,
            itemValor: null,
            itemPlanoNome: null,
            itemPlanoVlAtivacao: null,
            itemPlanoVlCancelar: null,
            itemPlanoVlReativacao: null,
            itemPlanoBroker: null,
            itemPlanoBrokerId: null,
            itemPlanoOperadora: null,
            itemPlanoPacote: null,
            itemDescontos: [],
            IdPedidoItem: null,
            condicaoSelected: '1',
            itemValorMinimo: null,
            tabelaSelecionada: null,
            servicoSelecionado: null,
            nomeTipoItem: null
        };
        this.itensPedidoServico = [...this.itensPedidoServico, o];
    }

    alterarCondicaoSelecionda(item, i) {
        this.itensPedidoServico[i].condicaoSelected = item;
    }

    deleteItem(id) {
        for (let i = 0; i < this.itensPedidoProduto.length; i++) {
            if (this.itensPedidoProduto.indexOf(this.itensPedidoProduto[i]) === id) {
                this.itensPedidoProduto.splice(i, 1);
                break;
            }
        }
        this.alterarTotal()
    }

    deleteItemProdutoServico(id) {
        for (let i = 0; i < this.itensPedidoServico.length; i++) {
            if (this.itensPedidoServico.indexOf(this.itensPedidoServico[i]) === id) {
                this.itensPedidoServico.splice(i, 1);
                break;
            }
        }
        this.alterarTotal()
    }


    selectItem(item, index) {
        this.itensPedidoProduto[index].itemTipo = item.target.value;
        // this.itensPedidoServico[index].itemTipo = item.target.value;
    }
    // selectItem(item, index) {
    //     console.log('Index:', index);
    //     console.log('this.itensPedidoProduto:', this.itensPedidoProduto);
    //     console.log('this.itensPedidoServico:', this.itensPedidoServico);

    //     if (this.itensPedidoProduto && this.itensPedidoProduto[index]) {
    //         this.itensPedidoProduto[index].itemTipo = item.target.value;
    //     } else {
    //         console.warn(`itensPedidoProduto[${index}] está indefinido`);
    //     }

    //     if (this.itensPedidoServico && this.itensPedidoServico[index]) {
    //         this.itensPedidoServico[index].itemTipo = item.target.value;
    //     } else {
    //         console.warn(`itensPedidoServico[${index}] está indefinido`);
    //     }
    // }


    selectItemTabelaPreco(item, index) {
        this.itensPedidoServico[index].condicaoSelected = item.target.value;
    }

    selecionarServico(item, index) {
        this.itensPedidoServico[index].servicoSelecionado = item.target.value;
        const pedidoObj = this.tipoItemServico.find(item => item.id_servico == this.itensPedidoServico[index].servicoSelecionado)
        // this.itensPedidoServico[index].itemTipo = pedidoObj.id_servico
        this.itensPedidoServico[index].itemValorMinimo = pedidoObj.valor_minimo;
        
    }



    alterarTotal() {
        this.valorTotal = 0
        this.itensPedidoProduto.forEach(item => {
            this.valorTotal = this.valorTotal + (item.itemValor * item.quantidade)
        });
        this.itensPedidoServico.forEach(item => {
            this.valorTotal = this.valorTotal + (item.itemValor * item.quantidade)
        });
    }
}